import React from 'react';
import {AnnouncementContent} from './sub-view/announcement-content';
import {UserLayout} from 'components/layouts/user';

class AnnouncementContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active="announcements">
        <h1 className="user-header">Thông báo</h1>
        <AnnouncementContent/>
      </UserLayout>
    );
  }
}

export default AnnouncementContainer;



// WEBPACK FOOTER //
// ./components/users/AnnouncementContainer.jsx